import { Action, createReducer, on } from '@ngrx/store';
import {
  setStateAction,
  nextStepFactoryAction,
  previousStepFactoryAction,
  clearFactoryEntryAction,
  clearWithLegacyFactoryEntryAction,
} from '../actions/factory.actions';

export interface FactoryReducerInitialState {
  entry?: Record<string, any>;
  currentStep: number;
  legacyData?: Record<string, any>;
}

export const initialState: FactoryReducerInitialState = {
  entry: {},
  currentStep: 0,
  legacyData: null,
};

const reducer = createReducer(
  initialState,
  on(setStateAction, (state, payload) => {
    return {
      ...state,
      ...payload,
    };
  }),
  on(nextStepFactoryAction, (state, payload) => ({
    ...state,
    entry: {
      ...state.entry,
      ...payload,
    },
    currentStep:
      state.currentStep < 4 ? state.currentStep + 1 : state.currentStep,
  })),
  on(previousStepFactoryAction, (state, payload) => ({
    ...state,
    currentStep:
      state.currentStep !== 0 ? state.currentStep - 1 : state.currentStep,
  })),
  on(clearFactoryEntryAction, (state, payload) => ({
    ...state,
    currentStep: 0,
    entry: {},
  })),
  on(clearWithLegacyFactoryEntryAction, (state, payload) => ({
    ...state,
    currentStep: 0,
    entry: {},
    legacyData: null,
  }))
);

export function factoryReducer(
  state: FactoryReducerInitialState,
  action: Action
) {
  return reducer(state, action);
}
